import SiteProvider from "./src/context/SiteContext";
export const wrapRootElement = SiteProvider; // wraps site in SiteProvider
